module.exports = __webpack_public_path__ + "static/media/sfx_animal_tiger.cbe356b5.mp3";